export default "__VITE_ASSET__d6a98625__"